module.exports = __webpack_public_path__ + "static/media/round-clear-24px.21f12993.svg";